import React, { FC, useEffect, useState } from 'react'
import queryString from 'query-string'
import GoogleLogin from 'react-google-login'
import { useDispatch, useSelector } from 'react-redux'

import { oneClickSignon,
  postAddAgendas,
  outlookAuth,
  iCloudAuth } from '../../api/api'

import ReactLoginMS from 'react-ms-login'
import ReactGA from 'react-ga'

import iCloudLogo from '../../assets/img/icloud.png'

import './styles.scss'
import { createCookie } from '../../utils/cookies'
import { Plann3rStore } from '../../store/types'
import { SettingsStore } from '../../store/settings/types'

import { IProps } from './types'
import { requestSettings } from '../../store/settings/actions'
import Loading from '../loading/Loading'
import { APP_URL, MS_CLIENT_ID } from '../../constants'
import { Agenda, ApiResponse, Calendar } from '../../types/plann3r'
import { isValidEmail } from '../../utils/general'

const Calendars: FC<IProps> = ({ nextThingNewAccount, nextThing, nextThingText, oneIsEnough = true }) => {
  // REDUX STORE
  const { calendars } = useSelector((state: Plann3rStore): SettingsStore => state.settings)
  const strings = useSelector((state: Plann3rStore) => state.languages.strings.calendars)
  const dispatch = useDispatch()

  // State
  const [icloud_selected, seticloud_selected] = useState(false)
  const [pick_agendas, setpick_agendas] = useState(false)
  const [agendas, setagendas] = useState<Agenda[]>([])
  const [selectedAgendas, setselectedAgendas] = useState<Agenda[]>([])
  const [minimumOneCalendar, setminimumOneCalendar] = useState(false)
  const [error, seterror] = useState('')
  const [isFetching, setisFetching] = useState(false)
  const [agendaType, setagendaType] = useState('')
  const [agendaEmail, setagendaEmail] = useState('')
  const [icloudEmail, seticloudEmail] = useState('')
  const [icloudPassword, seticloudPassword] = useState('')

  useEffect(() => {
    // capture google login code
    const parsed = queryString.parse(location.hash)

    if (parsed.code) {
      addGoogle({
        code: Array.isArray(parsed.code) ? parsed.code[0] : parsed.code,
        url: window.location.href,
      })
    }
  })

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const addGoogle = async (response: any) => { // { code: string; url: string}
    const oneclick_info = {
      type: 'Google',
      token: decodeURIComponent(response.code),
      url: response.url,
    }
    setisFetching(true)
    handleOneClickSignOnReceived(await oneClickSignon(oneclick_info))
  }

  const addAgendas = async () => {
    const obj = {
      agendas: selectedAgendas,
      agenda_type: agendaType,
      agenda_email: agendaEmail,
    }
    handleAddAgendasReceived(await postAddAgendas(obj))
  }

  const addOutlook = async (code: string) => {
    console.log(code, 'code')
    setisFetching(true)
    console.log('setisFetching')
    handleOneClickSignOnReceived(await outlookAuth(code))
    console.log('handleOneClickSignOnReceived')
  }

  const authICloud = async (e: React.FormEvent<HTMLFormElement>) => {
    if (icloudEmail !== '' && isValidEmail(icloudEmail) && icloudPassword !== '') {
      e.preventDefault()
      const icloud_info = {
        email: icloudEmail,
        password: icloudPassword,
      }
      setisFetching(true)
      handleOneClickSignOnReceived(await iCloudAuth(icloud_info))
    }
    else {
      alert('Missing ad/or wrong data.')
    }
  }

  const closeModal = (e?: React.MouseEvent<HTMLDivElement, MouseEvent> | React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (e) e.preventDefault()
    seticloud_selected(false)
    setpick_agendas(false)
  }

  const handleAddAgendasReceived = (response: ApiResponse) => {
    if (response.success) {
      ReactGA.event({
        category: 'User',
        action: 'Created an Account',
      })
      closeModal()
      if (oneIsEnough) {
        nextThingNewAccount()
      }
    } else {
      seterror(response.reason ?? '')
    }
    dispatch(requestSettings())
  }

  const handleChange = (agendaId: string, agendaName: string, event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked
    const agendas: Agenda[] = selectedAgendas.slice()
    const agenda = {
      name: agendaName,
      agenda_name: agendaName,
      id: agendaId,
    }

    if (isChecked) {
      agendas.push(agenda)
    } else {
      const index = agendas.map((agenda) => agenda.id).indexOf(agendaId)
      agendas.splice(index, 1)
    }

    setselectedAgendas(agendas)
  }

  const handleOneClickSignOnReceived = (response: ApiResponse) => {
    ReactGA.event({
      category: 'User',
      action: 'Loged-in',
    })

    console.log('handleOneClickSignOnReceived 1')
    if (response.success && response.token) {
      closeModal()
      seterror('')
      setisFetching(false)

      console.log('handleOneClickSignOnReceived 2')
      if (response.token) {
        createCookie('token', response.token, 60)
        setminimumOneCalendar(true)
        seticloud_selected(false)
        setpick_agendas(false)
      }

      console.log('handleOneClickSignOnReceived 3')
      if (response.id) {
        ReactGA.set({ userId: response.id })
      }

      if (response.agendas && response.agenda_application && response.agenda_email) {
        seticloud_selected(false)
        setpick_agendas(true)
        setagendas(response.agendas)
        setagendaType(response.agenda_application)
        setagendaEmail(response.agenda_email)
      } else {
        if (oneIsEnough) {
          nextThing()
        }
        dispatch(requestSettings())
      }
    } else {
      seterror(response.error ?? '')
      setisFetching(false)
    }

    console.log('handleOneClickSignOnReceived 4')
  }

  let modal_content

  if (icloud_selected) {
    modal_content = (
      <form onSubmit={authICloud}>
        <div className="has-text-centered">
          <img src={iCloudLogo} className="icloudLogo" alt="iCloud" />
        </div>
        {error}
        <div className="field">
          <label htmlFor="iCloudEmail">{strings.icloud.email}</label>
          <div className="control is-expanded">
            <input
              type="email"
              className="input is-fullwidth"
              placeholder={strings.icloud.email_placeholder}
              required
              onChange={(e) => seticloudEmail(e.target.value)}
            />
          </div>
        </div>
        <div className="field">
          <label htmlFor="iCloudPassword">{strings.icloud.password}</label>
          <div className="control is-expanded">
            <input
              type="password"
              className="input is-fullwidth"
              placeholder="********"
              onChange={(e) => seticloudPassword(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="field">
          <div className="control">
            <button className="button is-primary icloudButtonAdd">
              {strings.icloud.add_calendar_button}
            </button>
          </div>
        </div>
      </form>
    )
  } else if (pick_agendas) {
    modal_content = (
      <div>
        <h3>{strings.planner_selected}</h3>
        <ul className="renderAgendas">
          {agendas.map((agenda: Agenda) => {
            const isChecked =
              selectedAgendas.map((e: Agenda) => e.id).indexOf(agenda.id) >
              -1

            return (
              <li key={agenda.id}>
                <label>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => handleChange(agenda.id, agenda.name, e)}
                  />
                  {agenda.name}
                </label>
              </li>
            )
          })}
        </ul>
        <button className="button is-primary morePadding" onClick={addAgendas}>
          {strings.select}
        </button>
        <div style={{ marginTop: '15px' }}>
          <input type="checkbox" />
          <span style={{ marginLeft: '5px' }}>
            {strings.accept.text}
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              {strings.accept.link}
            </a>
            .
          </span>
        </div>
        {error}
      </div>
    )
  } else {
    modal_content = <div>{strings.no_content}</div>
  }

  return (
    <div>
      <div className="calendars no-heavy-text">
        <div className="error">
          <div dangerouslySetInnerHTML={{ __html: error }} />
        </div>
        {isFetching && <Loading />}
        <div
          className={
            minimumOneCalendar || calendars.length > 0
              ? 'calendarsSection'
              : 'calendarsSection is-hidden'
          }
        >
          <h2 className="has-text-centered">{strings.linked_calender}</h2>
          <ul className="renderCalendars">
            {calendars.map((calendar: Calendar) => {
              return (
                <li key={calendar.calendar_id}>
                  <p>
                    {calendar.name} - {calendar.email}
                  </p>
                </li>
              )
            })}
          </ul>
        </div>
        <button
          className={
            minimumOneCalendar || calendars.length > 0
              ? 'button is-primary submitCalendars submitCalendarsMargin'
              : 'button is-primary is-hidden submitCalendars submitCalendarsMargin'
          }
          onClick={() => nextThing()}
        >
          {nextThingText}
        </button>
        <ul className="calendarslist">
          <li className="calendarButton">
            <GoogleLogin
              clientId="1052919554325-t86chjvlisfr8se7o3lbi519787hnngm.apps.googleusercontent.com"
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              onSuccess={(response: any) => addGoogle(response)}
              // eslint-disable-next-line no-console
              onFailure={(response: any) => console.log('failed', response)}
              scope="profile email https://www.google.com/calendar/feeds/"
              responseType="code"
              className="googleButton"
              redirectUri="https://master.d1g15sy19z0a8o.amplifyapp.com"
              uxMode="redirect"
              cookiePolicy={'single_host_origin'}
            >
              <span />
            </GoogleLogin>
          </li>
          <hr />
          <li className="calendarButton">
            <div
              className="icloudButton"
              onClick={() => {
                seticloud_selected(true)
              }}
              role="presentation"
            />
          </li>
          <hr />
          <li>
            <ReactLoginMS
              clientId={MS_CLIENT_ID} // required: 'application id/client id' obtained from https://apps.dev.microsoft.com for your app
              redirectUri={APP_URL + '/outlook.html'} // required: redirectUri registered in https://apps.dev.microsoft.com for your app
              scopes={[
                'openid',
                'https://outlook.office.com/calendars.readwrite',
                'offline_access',
              ]}
              //optional: defaults to "user.read" full list is present
              // https://developer.microsoft.com/en-us/graph/docs/concepts/permissions_reference
              responseType="code" //optional: valid values are "token" for `Implicite OAuth flow` and "code" for `Authorization Code flow` defaults to "token"
              cssClass="office365Button" // optional: space separated class names which are applied on the html Button element
              btnContent={<span />} // optional: can be string or a valid react component which can be rendered inside html Button element
              //handleLogin={(data) => console.log(data)}// required: callback to receive token/code after successful login
              // eslint-disable-next-line max-len
              handleLogin={(response: {code: string}) => addOutlook(response.code)} // required: callback to receive token/code after successful login
            />
          </li>
          <hr />
          <li className="addCalendarOther h-full">
            {strings.using_exchange.part1} <br />
            {strings.using_exchange.part2}{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="mailto:support@plann3r.com"
            >
              {strings.using_exchange.part3}
            </a>{' '}
            {strings.using_exchange.part4}
          </li>
        </ul>
      </div>
      <div
        className={
          'modal' + (icloud_selected || pick_agendas ? ' is-active' : '')
        }
      >
        <div className="modal-background" onClick={() => closeModal} role="presentation" />
        <div className="modal-content">
          <div className="box">{modal_content}</div>
        </div>
        <button className="modal-close" onClick={() => closeModal} />
      </div>
    </div>
  )
}

export default Calendars
